import { Box } from "@mui/material";
import type { FC, ReactNode } from "react";
import { DASHBOARD_TRANSITION_DURATION_MS } from "web_myplann/Dashboard/Utils/dashboardLayout";

type Props = {
	transform: string;
	isAnimated: boolean;
	isFront: boolean;
	children: ReactNode;
};

export const DashboardCardSlot: FC<Props> = ({
	transform,
	isAnimated,
	isFront,
	children,
}) => (
	<Box
		position="absolute"
		top={0}
		left={0}
		right={0}
		bottom={0}
		width="100%"
		aria-hidden={!isFront || undefined}
		inert={!isFront || undefined}
		sx={{
			transform,
			transition: isAnimated
				? `transform ${DASHBOARD_TRANSITION_DURATION_MS}ms ease-in-out`
				: "none",
			willChange: "transform",
			pointerEvents: isFront ? undefined : "none",
		}}
	>
		{children}
	</Box>
);
